import { lazy } from 'react';
import { ALPHA_ID_PREFIXES, isValidAlphaID } from '@theguarantors/tg-modern-business';

import { routes } from '@/constants/Constants';

const ClaimsDashboardRoute = lazy(() => import('./routes/claims-dashboard.route'));
const ClaimsSubmissionFormRoute = lazy(() => import('./routes/claims-submission-form.route'));
const ClaimsSubmissionConfirmationRoute = lazy(
  () => import('./routes/claims-submission-confirmation.route'),
);
const ClaimsSubmissionDetailsRoute = lazy(() => import('./routes/claims-submission-details.route'));
const ClaimsReportRoute = lazy(() => import('./routes/claims-report.route'));
const ClaimsRedirectRoute = lazy(() => import('./routes/claims-redirect.route'));

const matchesClaimsSubmissionDetailsPath = (pathname: string) => {
  const segments = pathname.split('/');
  const claimAlphaId = segments[2];
  const claimSubmissionAlphaId = segments[4];

  return Boolean(
    claimAlphaId &&
    claimSubmissionAlphaId &&
    isValidAlphaID(ALPHA_ID_PREFIXES.CLAIM, claimAlphaId) &&
    isValidAlphaID(ALPHA_ID_PREFIXES.CLAIM_SUBMISSION, claimSubmissionAlphaId),
  );
};

export const claimsRoutes = [
  {
    path: routes.claimsDashboard,
    component: ClaimsDashboardRoute,
    title: 'Claims Dashboard | TheGuarantors',
  },
  {
    path: routes.claimsForm,
    component: ClaimsSubmissionFormRoute,
    title: 'File a Claim | TheGuarantors',
    handle: { hasBreadcrumbs: true },
  },
  {
    path: routes.claimsFormConfirmation,
    component: ClaimsSubmissionConfirmationRoute,
    title: 'Thank You | TheGuarantors',
  },
  {
    path: routes.claimsSubmissionDetails,
    component: ClaimsSubmissionDetailsRoute,
    title: 'Claim Submission | TheGuarantors',
    matchesPath: matchesClaimsSubmissionDetailsPath,
    handle: { hasBreadcrumbs: true },
  },
  {
    path: routes.claimsRedirect,
    component: ClaimsRedirectRoute,
    title: 'TheGuarantors',
  },
  {
    path: routes.claimsReport,
    component: ClaimsReportRoute,
    title: 'Claims Report | TheGuarantors',
  },
  {
    path: '/track-claims',
    component: ClaimsRedirectRoute,
    title: 'Claims Report | TheGuarantors',
  },
  {
    path: '/claims/instructions',
    component: ClaimsRedirectRoute,
    title: 'File a Claim | TheGuarantors',
  },
];
